import { datadogRum } from '@datadog/browser-rum';

const HOST_MAP = {
  'phonesheet.unitedtalent.com': 'prod',
  'phonesheet.staging.unitedtalent.com': 'staging',
  'phonesheet.qa.unitedtalent.com': 'dev',
  localhost: 'local',
};

/**
 * Initializes data dog for the appropriate host (environment)
 *
 * @param { string } host:
 * @param { string[] } allowableEnvs: a list of allowable environments to track.
 */
export const initializeDataDog = (host, allowableEnvs) => {
  const env = HOST_MAP[host];
  if (allowableEnvs.includes(env)) {
    datadogRum.init({
      env,
      version: '0.3.1',
      service: 'phonesheet-united-talent',
      site: 'us3.datadoghq.com',
      applicationId: '586f76bf-cbbb-489f-a3b9-835c7e23f1ad',
      clientToken: 'pub7b8710f13c4204727adbeadeec9a57ad',
      allowedTracingOrigins: ['https://api.unitedtalent.com', /https:\/\/.*\.unitedtalent\.com/],
      sampleRate: 100,
      replaySampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'allow',
    });
  }
};
